import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import AdminSidebar from "../components/AdminSidebar";
import "../css/admin.css";

function AdminAnnouncement() {

    const [announcements, setAnnouncements] = useState([]);

    const [showForm, setShowForm] = useState(false);

    const [editingId, setEditingId] = useState(null);

    const [form, setForm] = useState({
        message: "",
        background_color: "#7b1e3a",
        text_color: "#ffffff",
        status: "Active"
    });

    useEffect(() => {
        loadAnnouncements();
    }, []);

    const config = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
        }
    };

    const loadAnnouncements = () => {

        axios
        .get(`${API_URL}/admin/announcements`, config)
        .then((res) => {
            setAnnouncements(res.data);
        })
        .catch(console.log);

    };

    const handleChange = (e) => {

        setForm({
            ...form,
            [e.target.name]: e.target.value
        });

    };

    const saveAnnouncement = async () => {

        try {

            if (editingId) {

                await axios.put(
                    `${API_URL}/admin/announcements/${editingId}`,
                    form,
                    config
                );

                alert("Announcement Updated");

            } else {

                await axios.post(
                    `${API_URL}/admin/announcements`,
                    form,
                    config
                );

                alert("Announcement Added");

            }

            setEditingId(null);

            setShowForm(false);

            setForm({
                message: "",
                background_color: "#7b1e3a",
                text_color: "#ffffff",
                status: "Active"
            });

            loadAnnouncements();

        } catch (err) {

            console.log(err);

        }

    };

 const editAnnouncement = (item) => {

    setEditingId(item.id);

    setForm({

        message: item.message,

        background_color: item.background_color,

        text_color: item.text_color,

        status: item.status

    });

    setShowForm(true);

};

    const deleteAnnouncement = async (id) => {

        if (!window.confirm("Delete Announcement?"))
            return;

        await axios.delete(
            `${API_URL}/admin/announcements/${id}`,
            config
        );

        loadAnnouncements();

    };

    return (

        <div className="admin-layout">

            <AdminSidebar />

            <div className="admin-content">

                <h1>Announcement Management</h1>

                <button
                    className="edit-btn"
                    onClick={() => {
                        setEditingId(null);
                        setShowForm(!showForm);
                    }}
                >
                    {showForm ? "Close Form" : "Add Announcement"}
                </button>

                {showForm && (

                    <div className="edit-product-box">

                        <input
                            type="text"
                            name="message"
                            placeholder="Announcement Message"
                            value={form.message}
                            onChange={handleChange}
                        />

                        <label>Background Color</label>

                        <input
                            type="color"
                            name="background_color"
                            value={form.background_color}
                            onChange={handleChange}
                        />

                        <label>Text Color</label>

                        <input
                            type="color"
                            name="text_color"
                            value={form.text_color}
                            onChange={handleChange}
                        />

                        <select
                            name="status"
                            value={form.status}
                            onChange={handleChange}
                        >
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </select>

                        <button
                            className="edit-btn"
                            onClick={saveAnnouncement}
                        >
                            {editingId ? "Update" : "Save"}
                        </button>

                    </div>

                )}

                <table className="admin-table">

                    <thead>

                        <tr>

                            <th>ID</th>

                            <th>Message</th>

                            <th>Background</th>

                            <th>Text</th>

                            <th>Status</th>

                            <th>Action</th>

                        </tr>

                    </thead>

                    <tbody>

                        {announcements.map((item) => (

                            <tr key={item.id}>

                                <td>{item.id}</td>

                                <td>{item.message}</td>

                                <td>{item.background_color}</td>

                                <td>{item.text_color}</td>

                                <td>{item.status}</td>

                                <td>

                                    <button
                                        className="edit-btn"
                                        onClick={() => editAnnouncement(item)}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() => deleteAnnouncement(item.id)}
                                    >
                                        Delete
                                    </button>

                                </td>

                            </tr>

                        ))}

                    </tbody>

                </table>

            </div>

        </div>

    );

}

export default AdminAnnouncement;